import React from 'react';
import { LeagueOutput } from '../generated-api';
import { resolveLeagueIcon } from '../utils/leagueIcon';

interface LeagueTabNavigationProps {
  leagues: LeagueOutput[];
  playLeagueIds: string[];
  selectedLeagueId: string;
  onLeagueSelect: (leagueId: string) => void;
}

const LeagueTabNavigation: React.FC<LeagueTabNavigationProps> = ({
  leagues,
  playLeagueIds,
  selectedLeagueId,
  onLeagueSelect
}) => {
  const relevantLeagues = leagues.filter(league => playLeagueIds.includes(league.id));

  if (relevantLeagues.length <= 1) {
    // Don't show tabs if there's only one league
    return null;
  }

  return (
    <div className="border-b border-edge mb-6">
      <nav className="-mb-px flex space-x-8 overflow-x-auto" aria-label="League Tabs">
        {relevantLeagues.map((league) => (
          <button
            data-track="league_tab"
            key={league.id}
            onClick={() => onLeagueSelect(league.id)}
            className={`whitespace-nowrap min-h-[44px] sm:min-h-0 py-2 px-1 border-b-2 font-medium text-sm focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 ${
              selectedLeagueId === league.id
                ? 'border-primary-500 text-primary-700'
                : 'border-transparent text-muted hover:text-body hover:border-edge-input'
            }`}
            aria-current={selectedLeagueId === league.id ? 'page' : undefined}
          >
            <span className="mr-2">
              {resolveLeagueIcon(league.icon, league.isGlobal ? '🌍' : '🏆')}
            </span>
            {league.name}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default LeagueTabNavigation;